import {Alert, Button} from "@mui/material"
import AppContext from "../../contexts/AppContext";
import { useContext, useState } from "react";
import { logoutAdmin } from "../../helperFunctions/api";



export default function LogoutButton() {


  let { navigate } = useContext(AppContext);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");


  const handleLogout = async () => {
    if (pending) return;
    setPending(true);
    setError("");
    try {
      await logoutAdmin();
      navigate("/");
    } catch (err) {
      console.error("Admin logout failed:", err.message);
      setError(err.message);
    } finally {
      setPending(false);
    }
  };

  return (
      <>
      {error && <Alert severity="error">{error}</Alert>}
      <Button disabled={pending} onClick={() => handleLogout()} color="inherit">
        Logout
      </Button>
      </>

  );
}
